<template>
  <div class="base-accordion js-base-accordion">
    <slot :onCollapse="onCollapse" :opened="opened"></slot>
  </div>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      value: Boolean
    },
    data () {
      return {
        opened: false
      }
    },
    methods: {
      onCollapse () {
        this.opened = !this.opened
      },
      open (uid) {
        if(uid === this._uid) {
          this.opened = true
        }
      }
    },
    created () {
      this.$eventBus.$on('openBaseAccordion', this.open)
      this.opened = this.value
    },
    beforeDestroy () {
      this.$eventBus.$off('openBaseAccordion', this.open)
    }
  }
</script>

<style lang="scss">
  .base-accordion {
    
  }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseAccordion.vue